import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $processing, $done } from '../activity/action';

export const MODULE = 'Dashboard';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $receivable = ActionCreator.Async(MODULE, 'Receivable', (payload) => {
  return async (dispatch) => {
    dispatch($processing($receivable.OPERATION));

    return await Rest.GET(`${API_URL}/finance/report/dashboard`, payload)
      .then((response) => {
        dispatch($receivable.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($receivable.OPERATION)));
  };
});
